
export const FloatingShapes = () => {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {[...Array(20)].map((_, i) => (
        <div
          key={i}
          className="absolute animate-float"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 5}s`,
            opacity: 0.1
          }}
        >
          <div className="w-12 h-12 rotate-45 bg-indigo-500 rounded-lg"></div>
        </div>
      ))}
    </div>
  );
};